<template>
  <b-card>
    <layout-loading v-if="itemLoading" />
    <b-form v-if="render">
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('general.language')"
            label-for="service-lang"
            class="mb-2"
          >
            <languageSelector
              v-model="form.lang"
              @change-selected-language="changeSelectedLanguage"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            :label="$t('comments.content')"
            label-for="comment-content"
          >
            <b-form-textarea
              id="comment-content"
              v-model="form.content"
              rows="6"
              :state="validateState('content')"
            />
            <b-form-invalid
              id="input-content-feedback"
              :label="$t('general.content')"
              :validator="$v.form.content"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="6"
          cols="12"
        >
          <b-form-group
            :label="$t('comments.status')"
            label-for="comment-status"
          >
            <b-form-checkbox
              id="comment-status"
              v-model="form.status"
              class="mt-1"
              name="comment-status"
              switch
              inline
            />
            <b-form-invalid
              id="input-status-feedback"
              :label="$t('general.status')"
              :validator="$v.form.status"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="6"
          cols="12"
        >
          <b-form-group
            :label="$t('comments.report')"
            label-for="comment-report"
          >
            <b-form-checkbox
              id="comment-report"
              v-model="form.report"
              name="comment-report"
              class="mt-1"
              switch
              inline
            />
            <b-form-invalid
              id="input-report-feedback"
              :label="$t('general.report')"
              :validator="$v.form.report"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          sm="6"
          cols="12"
        >
          <b-form-group
            :label="$t('comments.like')"
            label-for="comment-like"
            class="mb-2"
          >
            <b-form-input
              id="comment-like"
              v-model="form.like"
              name="comment-like"
              :state="validateState('like')"
            />
            <b-form-invalid
              id="input-like-feedback"
              :label="$t('general.like')"
              :validator="$v.form.like"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="4"
          sm="6"
          cols="12"
        >
          <b-form-group
            :label="$t('comments.rate')"
            label-for="comment-rate"
          >
            <star-rating
              id="comment-rate"
              v-model="form.rate"
              class="mt-1"
              name="comment-rate"
              :star-size="25"
              inactive-color="#535454"
              :show-rating="false"
              rounded-corners
              :padding="2"
            />
            <b-form-invalid
              id="input-rate-feedback"
              :label="$t('general.rate')"
              :validator="$v.form.rate"
              :is-bootstrap="false"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <!--/ form -->
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, numeric } from 'vuelidate/lib/validators'
import StarRating from 'vue-star-rating'
import LayoutLoading from '@/components/LayoutLoading.vue'
import languageSelector from '@/components/language-selector.vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import useCommentList from './useCommentList'

export default {
  name: 'CommentEdit',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BFormTextarea,
    BRow,
    LayoutLoading,
    StarRating,
    languageSelector,
  },
  directives: {
    Ripple,
  },
  validations: {
    form: {
      content: { required },
      like: { required, numeric },
      status: { required },
      rate: { required },
      report: {},
    },
  },
  setup() {
    const {
      convertResource,
      fetchItem,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
    } = useCommentList()

    return {
      convertResource,
      fetchItem,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
    }
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchItem(this.itemId)
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    changeSelectedLanguage(val) {
      this.form = this.convertResource(this.item, val)
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.sendData(this.form)
    },
    sendData(form) {
      const data = {
        content: form.content,
        status: form.status,
        report: form.report,
        like: parseInt(form.like, 10),
        rate: form.rate,
      }
      this.updateItem(this.itemId, data, form.lang)
    },
  },
}
</script>
